<template>
  <div class="home">
    <div class="top-ctn">
      <div class="inpt">
        <button @click.prevent="cons">
          <img v-if="darkMode" src="../assets/loupe1.svg" alt="" />
          <img v-else src="../assets/loupe2.svg" alt="" />
        </button>
        <input
          @keydown.enter="cons"
          v-model="inpt"
          type="text"
          placeholder="Search for a country"
        />
      </div>
      <select @change="update" v-model="selected">
        <option value="" disabled selected>Filter by Region</option>
        <option>Africa</option>
        <option>Americas</option>
        <option>Asia</option>
        <option>Europe</option>
        <option>Oceania</option>
      </select>
    </div>

    <div class="card-ctn" v-if="pays">
      <router-link
        class="card"
        :to="{
          name: 'dtails',
          params: { id: pay.name },
        }"
        v-for="pay in payss"
        :key="pay.name"
      >
        <cards :pay="pay" />
      </router-link>
    </div>
    <button v-if="more" class="btnmore" @click.prevent="count++">More</button>
    <div @click="scrollToTop" class="btnup" v-if="payss.length >= 40">Up</div>
    <spinner v-if="!payss"/>
  </div>
  
</template>

<script>
import cards from "@/components/cards.vue";
import spinner from "@/components/spinner.vue";

export default {
  props: ["darkMode"],
  name: "Home",
  components: {
    "cards":cards,"spinner":spinner
  },
  data() {
    return {
      inpt: "",
      research: "",
      selected: "",
      pays: [],
      more: true,
      count: 1,
    };
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    cons() {
      this.research = this.inpt;
    },
    update() {
      this.research = "";
      this.inpt = "";
    },
  },
  computed: {
    payss() {
      var re = [];
      if (this.research !== "") {
        this.selected = "";
        this.research =
          this.research.charAt(0).toUpperCase() + this.research.slice(1);
        re = this.pays.filter((item) => item.name.startsWith(this.research));
        this.count = 1;
      } else if (this.selected !== "") {
        this.research = "";
        re = this.pays.filter((item) => item.region == this.selected);
      } else {
        re = this.pays;
      }
      let tmp = re.length;
      re = re.slice(0, this.count * 20);
      if (tmp == re.length) {
        this.more = false;
      } else {
        this.more = true;
      }
      return re;
    },
  },

  mounted() {
    fetch("https://restcountries.eu/rest/v2/all")
      .then((resp) => resp.json())
      .then((resp) => (this.pays = resp))
      .catch((Error) => alert(Error));
  },
};
</script>
